module.exports = __webpack_public_path__ + "img/TEXT.a752c958.svg";